__turbopack_context__.v({
  "button": "UGK4Ja_button",
  "content": "UGK4Ja_content",
  "fullWidth": "UGK4Ja_fullWidth",
  "md": "UGK4Ja_md",
  "primary": "UGK4Ja_primary",
  "quaternary": "UGK4Ja_quaternary",
  "secondary": "UGK4Ja_secondary",
  "shimmer": "UGK4Ja_shimmer",
  "sm": "UGK4Ja_sm",
  "tertiary": "UGK4Ja_tertiary",
  "text-bar-sweep": "UGK4Ja_text-bar-sweep",
});
